const MoodBackground =()=>{
    return (
        <div className={"moodBackground"}></div>
    )
}

export default MoodBackground